export default {
  plural: 'Twin Materials',
  createButton: 'Create material',
  createTitle: 'Add material',
  editTitle: 'Edit material',
  deleteTitle: 'Delete material',
  deleteWarning: 'Are you sure you want to delete this material?',
  company: 'Company',
  crmMaterial: 'CRM material',
  glbAsset: 'GLB asset',
  glbMaterialName: 'GLB material',
  swatchColor: 'Swatch color',
  materialGroup: 'Material group',
  noMaterials: 'No materials yet',
  addMaterial: 'Add material',
  backendBlocked: 'Waiting for backend support',
  bulkAddButton: 'Bulk add',
  bulkCreateTitle: 'Bulk add materials',
  crmMaterials: 'CRM materials',
  noGroup: 'Without a group',
  searchPlaceholder: 'Search zone...',
  selectZone: 'Pick a zone on the left to set up its materials',
  allowedCount: 'allowed',
  zones: {
    plural: 'Zones',
    noZones: 'No zones yet — parse a GLB asset with twinZone meshes',
    noTemplate: 'No zone template — create one to make this zone available',
    noMaterials: 'No allowed materials for this zone',
    createTemplate: 'Create template',
    save: 'Save',
    setDefault: 'Default'
  }
};
